import { Reveal } from "@/components/Reveal";
import { Storefront, ChartLineUp, Megaphone, Ticket, Star, ArrowUpRight } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

const CAP_KEYS = [
    { k: "claim", icon: Storefront },
    { k: "reviews", icon: Star },
    { k: "promote", icon: Megaphone },
    { k: "sell", icon: Ticket },
    { k: "analytics", icon: ChartLineUp },
];

const PLAN_KEYS = ["starter", "businessPro", "enterprise"];

export default function BusinessHub() {
    const { t } = useTranslation();

    return (
        <section id="business" className="relative py-32 md:py-40" data-testid="business-hub">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="grid lg:grid-cols-[1.05fr_1fr] gap-16 items-start">
                    <Reveal>
                        <div>
                            <div className="overline mb-4">{t("businessHub.overline")}</div>
                            <h2 className="font-serif text-5xl md:text-6xl text-white leading-[0.95] tracking-tighter">
                                {t("businessHub.title")}
                            </h2>
                            <p className="text-white/60 text-lg leading-relaxed mt-6 max-w-md">
                                {t("businessHub.subtitle")}
                            </p>

                            <div className="mt-10 space-y-8">
                                {PLAN_KEYS.map((key) => {
                                    const n = t(`businessHub.plans.${key}.n`);
                                    const pitch = t(`businessHub.plans.${key}.pitch`);
                                    return (
                                        <div key={key} className="flex items-center justify-between gap-6 py-6 border-t" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
                                            <div>
                                                <div className="font-serif text-2xl md:text-3xl text-white">{n}</div>
                                                <div className="text-white/60 text-sm mt-1">{pitch}</div>
                                            </div>
                                            <a href="#" className="shrink-0 w-11 h-11 rounded-full grid place-items-center border transition-colors duration-500 hover:bg-white/5"
                                                style={{ borderColor: "rgba(212,175,55,0.4)" }}
                                                data-testid={`business-plan-${n.toLowerCase().replace(/\s/g, '-')}`}>
                                                <ArrowUpRight size={16} color="#D4AF37" />
                                            </a>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </Reveal>

                    <div className="grid sm:grid-cols-2 gap-4">
                        {CAP_KEYS.map((c, i) => {
                            const Icon = c.icon;
                            const title = t(`businessHub.caps.${c.k}.title`);
                            const body = t(`businessHub.caps.${c.k}.body`);
                            return (
                                <Reveal key={c.k} delay={0.05 * i}>
                                    <div className="rounded-2xl p-6 h-full card-hover" style={{ background: "var(--navy-deep)", border: "1px solid rgba(255,255,255,0.06)" }} data-testid={`business-cap-${title.toLowerCase().replace(/\s/g, '-')}`}>
                                        <div className="w-11 h-11 rounded-full grid place-items-center mb-5" style={{ background: "rgba(212,175,55,0.08)", border: "1px solid rgba(212,175,55,0.3)" }}>
                                            <Icon size={18} color="#D4AF37" />
                                        </div>
                                        <div className="font-serif text-xl text-white leading-tight mb-2">{title}</div>
                                        <div className="text-white/60 text-sm leading-relaxed">{body}</div>
                                    </div>
                                </Reveal>
                            );
                        })}
                        <Reveal delay={0.25}>
                            <div className="rounded-2xl p-6 h-full flex flex-col justify-between" style={{ background: "linear-gradient(180deg, rgba(212,175,55,0.1), rgba(212,175,55,0.02))", border: "1px solid rgba(212,175,55,0.3)" }}>
                                <div>
                                    <div className="overline mb-3">{t("businessHub.ctaBox.overline")}</div>
                                    <div className="font-serif text-2xl text-white leading-tight">{t("businessHub.ctaBox.title")}</div>
                                </div>
                                <a href="#pricing" className="btn-gold mt-5 w-max" data-testid="business-cta">{t("businessHub.ctaBox.btn")}</a>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
